module.exports = __webpack_public_path__ + "img/rmrlogo-light.b222f2b8.png";